<div class="utr-modal-wrapper">
    <div class="utr-modal-header">
        <h3 class="utr-modal-header-text">
            {{ success ? 'Export Data' : 'Export in Progress...' }}
        </h3>
        <mat-icon class="utr-modal-close-icon" (click)="close()"
            >close</mat-icon
        >
    </div>
    <mat-dialog-content>
        <ng-container *ngIf="!success">
            <span class="export-message">
                You are about to export a large amount of data. Excel file can
                display up-to 10,000 records at a time. Consider filters and
                search to limit your data.
            </span>
        </ng-container>
    </mat-dialog-content>
    <div class="utr-modal-footer" *ngIf="!success">
        <button (click)="export(false)" mat-dialog-close class="cancel-btns">
            Cancel
        </button>
        <button (click)="export(true)" class="submit-btn">Export .xls</button>
    </div>
</div>
